import { useEffect, useState } from "react";
import { OrderTransport } from "src/app/transports/order";
import { UserModel } from "src/app/types/UserModel";
import { CheckRoles } from "src/app/utils/CheckRoles";

const useNumberOfOrderWithOutCategoriesByManager = (
    inicialCurrentUser?: UserModel,
    inicialRequest = true,
    inicialCallback?: (numberOfOrders: number) => void
) => {
    const [numberOfOrders, setNumberOfOrders] = useState<number>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const fetch = (currentUser?: UserModel, callback?: (numberOfOrders: number) => void) => {
        if (!currentUser || !CheckRoles.isLeadProjectManagerOrUnder(currentUser.role)) {
            return;
        }
        setLoading(true);
        OrderTransport.numberOfOrderWithOutCategoriesByManager()
            .then((res) => {
                setNumberOfOrders(res);
                callback && callback(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = (currentUser?: UserModel, callback?: (numberOfOrders: number) => void) => {
        if (!loading) return fetch(currentUser, callback);
    };

    useEffect(() => {
        if (inicialRequest) fetch(inicialCurrentUser, inicialCallback);
    }, []);

    return { numberOfOrders, refresh, loading, error };
};

export default useNumberOfOrderWithOutCategoriesByManager;
